/**
 * Canopy configurator step navigation
 * - Single goToStep / goToSubStep (validation before any UI change)
 * - Step 2 + step 7 mandatory validation
 * - Top .step-nav click navigation
 */
(function () {
  const MANDATORY_STEPS = {
    2: 'step2',
    7: 'step7'
  };

  const MANDATORY_ALERTS = {
    2: 'Please select at least one Rack Type before proceeding.',
    7: 'Please select at least one Delivery Option before proceeding.'
  };

  let currentStep = 1;
  let currentSubStep = '5a';

  function isStepValid(stepId) {
    const step = document.getElementById(stepId);
    if (!step) return true;

    const checkboxes = step.querySelectorAll('.addon-checkbox');
    if (!checkboxes.length) return true;

    return Array.from(checkboxes).some(function (cb) {
      return cb.checked;
    });
  }

  function canNavigateTo(stepNumber) {
    const target = parseInt(stepNumber, 10);
    if (isNaN(target) || target < 1 || target > 7) return false;

    // Leaving step 2 toward step 3+ requires rack type selection
    if (target > 2 && currentStep === 2 && !isStepValid('step2')) {
      alert(MANDATORY_ALERTS[2]);
      return false;
    }

    // Direct jump forward from step 1 to 3+ also requires step 2 if we're validating forward only when crossing 2->3
    if (target >= 3 && !isStepValid('step2')) {
      const step2 = document.getElementById('step2');
      const hasStep2Options = step2 && step2.querySelectorAll('.addon-checkbox').length > 0;
      if (hasStep2Options) {
        alert(MANDATORY_ALERTS[2]);
        return false;
      }
    }

    return true;
  }

  function hideAllSteps() {
    document.querySelectorAll('#step1, .addon-row > .addons-column').forEach(function (step) {
      step.style.display = 'none';
    });
  }

  function updateStepNav(stepNumber) {
    let navStep = stepNumber;

    if (stepNumber === '5a' || stepNumber === '5b' || stepNumber === 5) {
      navStep = 5;
    }

    navStep = parseInt(navStep, 10);
    if (isNaN(navStep)) return;

    document.querySelectorAll('.step-nav .step').forEach(function (item, index) {
      item.classList.toggle('active', index + 1 === navStep);
    });
  }

  function showStepPanel(stepNumber) {
    hideAllSteps();

    const target = document.getElementById('step' + stepNumber);
    if (!target) return false;

    target.style.display = 'block';

    if (Number(stepNumber) === 5) {
      const step5a = document.getElementById('step5a');
      const step5b = document.getElementById('step5b');

      if (step5a) step5a.style.display = 'block';
      if (step5b) step5b.style.display = 'none';
      currentSubStep = '5a';
    }

    return true;
  }

  function goToStep(stepNumber) {
    const step = parseInt(stepNumber, 10);
    if (isNaN(step)) return false;

    if (!canNavigateTo(step)) {
      updateStepNav(currentStep);
      return false;
    }

    if (!showStepPanel(step)) return false;

    currentStep = step;
    updateStepNav(step);

    const wrapper = document.querySelector('.cd-conopay-info-wrepper');
    if (wrapper) {
      wrapper.classList.toggle('step-one-active', step === 1);
    }

    if (typeof window.updateTotalUI === 'function') {
      window.updateTotalUI();
    }

    return true;
  }

  function goToSubStep(stepName) {
    if (!canNavigateTo(5)) {
      updateStepNav(currentStep);
      return false;
    }

    hideAllSteps();

    const step5 = document.getElementById('step5');
    const step5a = document.getElementById('step5a');
    const step5b = document.getElementById('step5b');

    if (step5) step5.style.display = 'block';
    if (step5a) step5a.style.display = 'none';
    if (step5b) step5b.style.display = 'none';

    if (stepName === '5a' && step5a) {
      step5a.style.display = 'block';
      currentSubStep = '5a';
    }

    if (stepName === '5b' && step5b) {
      step5b.style.display = 'block';
      currentSubStep = '5b';
    }

    currentStep = 5;
    updateStepNav(5);

    if (typeof window.updateTotalUI === 'function') {
      window.updateTotalUI();
    }

    return true;
  }

  function bindStepNavClicks() {
    document.querySelectorAll('.step-nav .step').forEach(function (navItem, index) {
      if (navItem.dataset.navBound === '1') return;
      navItem.dataset.navBound = '1';

      navItem.style.cursor = 'pointer';

      navItem.addEventListener('click', function () {
        goToStep(index + 1);
      });
    });
  }

  function bindPopupValidation() {
    document.querySelectorAll('.open-popup-alert-btn').forEach(function (btn) {
      if (btn.dataset.step7Bound === '1') return;
      btn.dataset.step7Bound = '1';

      btn.addEventListener('click', function (e) {
        if (!isStepValid('step7')) {
          e.preventDefault();
          e.stopPropagation();
          alert(MANDATORY_ALERTS[7]);
          updateStepNav(currentStep);
          return false;
        }

        const popup = document.querySelector('.popup-contect-alert');
        if (popup) popup.classList.add('active');
      });
    });
  }

  function bindNavButtons() {
    document.querySelectorAll('.nav-buttons button[onclick]').forEach(function (btn) {
      if (btn.dataset.navBtnBound === '1') return;
      btn.dataset.navBtnBound = '1';

      const onclick = btn.getAttribute('onclick') || '';
      const stepMatch = onclick.match(/goToStep\((\d+)\)/);
      const subMatch = onclick.match(/goToSubStep\(['"]?(5a|5b)['"]?\)/);

      if (!stepMatch && !subMatch) return;

      btn.removeAttribute('onclick');

      btn.addEventListener('click', function (e) {
        e.preventDefault();

        if (subMatch) {
          goToSubStep(subMatch[1]);
        } else if (stepMatch) {
          goToStep(parseInt(stepMatch[1], 10));
        }
      });
    });
  }

  window.isStepValid = isStepValid;
  window.goToStep = goToStep;
  window.goToSubStep = goToSubStep;
  window.getConfiguratorCurrentStep = function () {
    return currentStep;
  };

  document.addEventListener('DOMContentLoaded', function () {
    bindStepNavClicks();
    bindPopupValidation();
    bindNavButtons();
    goToStep(1);
  });
})();
